import React, {useState, useCallback} from 'react'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import * as my from '../form/field/MyForm'
import { IconUpload } from '../icons'

const MAX_SIZE = 10 * 1000 * 1000 //10mb

const DropZone = ({
	size = {
		h: 32,
		w: 'full'
	},
	options = {},
	dropMessage: dropMessageInit = false,
	dropRequirements: dropRequirementsInit = false,
	css,
	onChange,
}) => {
		const { t } = useTranslation()
		const {
			getRootProps,
			getInputProps,
			isDragActive,
		} = useDropzone({ maxSize: MAX_SIZE, ...options })
		const dropMessage = dropMessageInit || t('form.field.drop_message')
		const dropRequirements = dropRequirementsInit || t('form.field.drop_requirements')

		// let className = `border-dashed border-4 border-${css?.borderColor || 'grey'}-200 dark:border-${css?.borderColor || 'grey'}-600 flex items-center justify-center p-8`;
		// for(let sizeKey in size){
		// 		if(!size.hasOwnProperty(sizeKey)) continue;
		// 		className += ` ${sizeKey}-${size[sizeKey]}`;
		// }

		//console.log('DropZone:', getRootProps(), getInputProps(), options, size, css, isDragActive)
		return <>
			<my.DropZone data-active={isDragActive} {...getRootProps()}>
				<my.DropInput {...getInputProps()} />
				<my.DropBox 
					data-active={isDragActive}
					// className={`${
					// 				isDragActive ? 'bg-grey-100 dark:bg-grey-800' : 'bg-grey-50 dark:bg-grey-700'
					// 		} ${className} `}
				>
					<IconUpload size={20} />
					<my.DropMessage>{dropMessage}</my.DropMessage>
					<my.DropRequirements>{dropRequirements}</my.DropRequirements>
				</my.DropBox>
			</my.DropZone>
		</>
}

export default DropZone
